<template>
    <div class="budget">
        <myhead :value="value" @next="next" @lookmore="more">{{
    $route.query.title || $route.meta.title
  }}</myhead>
  <div class="budget-header pad15" ref="budgetBox">
    <div class="BGon Cfff pad12 flex between">
        <div>
             <p class="mb20">账户结余</p>
             <p>¥{{ info.account_balance }} </p>
        </div>
        <div v-if="info.wusen_status" style="border:1px solid #fff;" class="padx3 pady1 radius5 size12">去使用</div>
        <div v-else style="border:1px solid #fff;" @click="freeze_show = true" class="padx3 pady1 radius5 size12">已冻结</div>

    </div>
    <van-tabs v-model:active="active" @click="onClickTab" title-active-color="#3F7C93" background="#fff">
        <van-tab :title="'文化收入 ￥'+  info.invest_amount "></van-tab>
        <van-tab :title="'商品支出 ￥'+ info.wusen_expenditure"></van-tab>
    </van-tabs>
  </div>
  <div class="content" :style="'padding-top:'+budgetHeight+'px'">
    <van-list v-if="!active" v-model:loading="invest_loading" :finished="invest_finished" finished-text="没有更多了" @load="onInvestLoad">
        <div v-for="item,index in income" :key="index" >
            <div class="flex between BGf6 weight title">
                <p>{{ item.name }}</p>
                <p>收入: {{ item.year.total }}</p>
            </div>
            <div  v-for="v,i in item.val" :key="i">
                <div class="pady10 BGwhite">
                    <div class="flex between padx15 size16 weight">
                    <p>{{ v.name }}</p>
                    <p class="Cred">+{{ v.total_amount }}</p>
                    </div>
                    <div class="flex between padx15  mt10 size14">
                        <p>{{ v.pay_time }}</p>
                        <p>{{ v.user_name }}</p>
                    </div>
                </div>
              </div>  
            
        </div>
    </van-list>
    <van-list v-else v-model:loading="wusen_loading" :finished="wusen_finished" finished-text="没有更多了" @load="onWusenLoad">
        <div v-for="item,index in wusen" :key="index"  >
            <div class="flex between BGf6 weight title">
                <p>{{ item.name }}</p>
                <p>支出: {{ item.year.total }}</p>
            </div>
            <div  v-for="v,i in item.val" :key="i">
                    <div class="pady10 BGwhite flex between mb10">
                        <div class="goods_pic  ml15" >
                            <img style="width:100%;height:100%" :src="item.original_img" :alt="item.original_img">
                        </div>
                        <div style="flex:1">
                            <div class="flex between padx15 size16 weight">
                            <div class="flex">
                                <p >{{ v.goods_name }}</p> 
                                <p class="size12 C888 ml10">{{ v.spec }}</p>
                            </div>
                            <p class="Cred" v-if="v.pay_status == 2">+{{ v.total_amount }}</p>
                            <p v-else class="Cred">-{{ v.total_amount }}</p>
                            </div>
                            <div class="flex between padx15  mt10 size14">
                                <p>{{ v.add_time }}</p>
                                <!-- <p>{{ v.user_name }}</p> -->
                            </div>
                        </div>
                        
                    </div>
                </div>
        </div>
    </van-list>
  </div>

    </div>
    
    <van-popup v-model:show="freeze_show"  :style="{ width: '80%' }">
        <div class="popup ">
            <div class="flex between BGon" style="padding:10px 15px;">
                <p></p>
                <p style="color:#fff">账户冻结说明</p>
                <van-icon name="cross" color="#fff" @click="freeze_show = false" />
            </div>
            <div class="pad15" >
                <p class="mb20">
                    抱歉，您的账户与{{ info.freeze_time }}发现异常现象，为保障您的资金安全，现已进行紧急冻结处理，请等待管路人员调查审核，如有问题可向管理人员提出意见反馈！
                </p>

                <van-button block round color="#3F7C93" @click="$router.push('/feedback')">意见反馈</van-button>
            </div>
        </div>
    </van-popup>
</template>


<script>
import ajax from "@/utils/request.js";
export default {
    data(){
        return{
            active:0,
            budgetHeight:0,
            info:{},
            income_list:[],
            income:[],
            wusen_list:[],
            wusen:[],
            invest_page:0,
            invest_loading:false,
            invest_finished:false,
            freeze_show:false,
            wusen_page:0,
            wusen_loading:false,
            wusen_finished:false,
        }
    },
    created(){
        this.init()
        this.investInit()

    },
    methods:{
        // 切换状态
        onClickTab(){
            if(this.active){
                this.wusen_page = 1
                this.wusen = []
                this.wusen_list = []
                this.wusenInit()
            }else{
                this.invest_page = 1
                this.income = []
                this.income_list = []
                this.investInit()
            }
        },
        init(){
            ajax.post("users/getbudget").then(res=>{
               if(res.errcode == 1){
                this.info = res.data
               }
            })
        },
        // 论文收入部分
        investInit(){
            // 获取文化收入详细
            ajax.post("users/getinvestamount",{page:this.invest_page}).then(res=>{
               if(res.errcode == 1){
                res.data.forEach(item => {
                    const date = item.pay_time;
                    const month = date.slice(0,7)
                    if(!this.income_list[month]){
                        this.income_list[month] = []
                        this.income_list[month].push(item)
                    }else{
                        this.income_list[month].push(item)
                    }                
                });
               const len = Object.keys(this.income_list).length
               this.investHandle(len,0)
               }
               if(res.data.length < 10){
                this.invest_finished = true
               }else{
                this.invest_page++
               }
            })
            .catch(()=>{
                this.invest_finished = true
            })
       
        },
        async getInvestTotal(val){
        const data = {
            years:val
        }
        const res = await ajax.post('users/getinvesttotal',data)
        return res.data
        },
        investHandle(len, num) {
            const i = Object.keys(this.income_list)[num]; //2023-09
            
            this.getInvestTotal(i).then(res => {
                const obj = this.income.find(item => {
                return item.name == i;
                });
                if (obj && this.income_list[i].length > obj.length) {
                this.income[i] = {
                    name: i,
                    year: res,
                    val: this.income_list[i]
                };
                }
                // 不存在新增该项
                else if (!this.income[i]) {
                    const data = {
                    name: i,
                    year: res,
                    val: this.income_list[i]
                }
                this.income.push(data)
                }
                if ((num+ 1) < len) {
                this.investHandle(len, num + 1);
                }
            });
        
        },
        onInvestLoad(){
            this.invest_loading = true;
        },
        // 雾森支出部分
        async getWusenTotal(val){
        const data = {
            years:val
        }
        const res = await ajax.post('users/getwusentotal',data)
        return res.data
        },
        onWusenLoad(){
            this.wusen_loading = false;
        },
        wusenHandle(len, num) {
            // 获取数组键值  日期
            const i = Object.keys(this.wusen_list)[num]; //2023-09
            // 获取该日期的总支出
            this.getWusenTotal(i).then(res => {
                // 获取该日期的数据
                const obj = this.wusen.find(item => {
                return item.name == i;
                });
                // 已经存在并且存在新数据，更新数据
                if (obj && this.wusen_list[i].length > obj.length) {
                this.wusen[i] = {
                    name: i,
                    year: res,
                    val: this.wusen_list[i]
                };
                }
                // 不存在新增该项
                else if (!this.wusen[i]) {
                    const data = {
                    name: i,
                    year: res,
                    val: this.wusen_list[i]
                }
                this.wusen.push(data)
                }
                // 处理下一个日期
                if ((num+ 1) < len) {
                this.wusenHandle(len, num + 1);
                }
            });
        
        },
        // wusen支付明细
        wusenInit(){
            ajax.post("users/getwusenamount",{page:this.wusen_page}).then(res=>{
                // 请求第一页的数据 10个
               if(res.errcode == 1){
                res.data.forEach(item => {
                    // 获取该数据的日期 年月
                    const date = item.add_time;
                    const month = date.slice(0,7)
                    // 判断该日期是否存在， 存在间数据添加至该日期内，不存在创建日期项并添加数据
                    if(!this.wusen_list[month]){
                        this.wusen_list[month] = []
                        this.wusen_list[month].push(item)
                    }else{
                        this.wusen_list[month].push(item)
                    }                
                });
                // 获取存在日期项数
               const len = Object.keys(this.wusen_list).length
               this.wusenHandle(len,0)
               }
               if(res.data.length < 10){
                this.wusen_finished = true
               }else{
                this.wusen_loading = false
                this.wusen_page++
               }
            })
            .finally(()=>{
                this.wusen_loading = false
            })
        }



    },
    mounted(){
        const budgetElement = this.$refs.budgetBox;
        if(budgetElement){
            this.budgetHeight = budgetElement.offsetHeight;
        }
    }

}
</script>

<style lang="scss" scoped>
.budget{
    width: 100%;
    height: 100%;
    background-color: #f6f6f6;
}
.budget-header{
    position: fixed;
    width: 100%;
    background-color: #fff;
    // z-index: 9;
}
.title{
    padding: 7px 15px;
}
.goods_pic{
    width: 14vw;
    height: 14vw;
    border-radius: 50%;
    overflow: hidden;
}
</style>